import { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
//Simple bar

import BreadCrumb from "../../Components/Common/BreadCrumb";

import classnames from "classnames";
import Loader from "../../Components/Common/Loader";

import { useFormik } from "formik";
import { Link, useHistory, useParams } from "react-router-dom";
import * as Yup from "yup";

import {
  useInnovation,
  useValidateInnovation,
} from "../../hooks/useInnovations";
import { normalizeBackendFileUrl } from "../../utils/backendApi";
import defaultIllustration from "../../assets/images/lcbtp.png";

function InnovationsDetail(props) {
  const history = useHistory();

  const { id } = useParams();
  const innovationQ = useInnovation(id);
  const validateMutation = useValidateInnovation();

  const selectAticle = innovationQ.data || {};
  const innovationImageUrl = normalizeBackendFileUrl(
    selectAticle.innovation_pic
  );

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      published: false,
    },

    validationSchema: Yup.object({
      published: Yup.boolean().required(),
    }),

    onSubmit: async (values) => {
      // The checkbox is a confirmation, not a payload: publishing goes through
      // PATCH /innovations/:id/publish/, which takes no body. Nothing used to
      // read it, so submitting with the box unticked still published.
      if (!values.published) {
        return;
      }
      try {
        await validateMutation.mutateAsync({ id });
        validation.resetForm();
        history.push("/innovations");
      } catch (_) {
        // handled by toast
      }
    },
  });

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  document.title = props.t("Détail d'une innovation");

  if (innovationQ.isLoading) return <Loader />;
  if (innovationQ.isError)
    return <Loader error={innovationQ.error?.message || "Erreur"} />;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Détail d'une innovation")}
          pageTitle={props.t("Innovation")}
        />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={12}>
                    <div className="mt-xl-0 mt-5">
                      <Row>
                        <Col lg={6}>
                          <img
                            src={innovationImageUrl || defaultIllustration}
                            alt={props.t("Illustration")}
                            className="rounded"
                            style={{ width: "100%" }}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = defaultIllustration;
                            }}
                          />
                        </Col>
                        <Col lg={6}>
                          <div className="product-content ">
                            <Nav tabs className="nav-tabs-custom nav-warning">
                              <NavItem>
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({
                                    active: customActiveTab === "1",
                                  })}
                                  onClick={() => {
                                    toggleCustom("1");
                                  }}
                                >
                                  {props.t("Détails")}
                                </NavLink>
                              </NavItem>
                            </Nav>

                            <TabContent
                              activeTab={customActiveTab}
                              className="border border-top-0 p-4"
                              id="nav-tabContent"
                            >
                              <TabPane id="nav-speci" tabId="1">
                                <div className="table-responsive">
                                  <table className="table mb-0">
                                    <tbody>
                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Statut")}
                                        </th>
                                        <td
                                          className="text-blue-500"
                                          style={{ color: "blue" }}
                                        >
                                          {!selectAticle.published ? (
                                            <div
                                              className="fs-12 uppercase badge badge-soft-danger"
                                              style={{
                                                textAlign: "center",
                                                fontSize: "13px",
                                              }}
                                            >
                                              {" "}
                                              En attente
                                            </div>
                                          ) : (
                                            <div
                                              className="fs-12 uppercase badge badge-soft-success"
                                              style={{
                                                textAlign: "center",
                                                fontSize: "13px",
                                              }}
                                            >
                                              {" "}
                                              Validé
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Auteur")}{" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {selectAticle.innovator &&
                                            selectAticle.innovator.username}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Email")}{" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {(selectAticle.innovator &&
                                            selectAticle.innovator.email) ||
                                            props.t("Non renseignée")}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Téléphone")}{" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {(selectAticle.innovator &&
                                            selectAticle.innovator
                                              .phone_number) ||
                                            props.t("Non renseignée")}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row"> {props.t("Nom")} </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {(selectAticle.innovator &&
                                            selectAticle.innovator.profile
                                              .last_name) ||
                                            props.t("Non renseignée")}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Prénom")}{" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {(selectAticle.innovator &&
                                            selectAticle.innovator.profile
                                              .first_name) ||
                                            props.t("Non renseignée")}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </TabPane>
                            </TabContent>
                          </div>
                        </Col>
                      </Row>
                      <div className="d-flex">
                        <div className="flex-wrap gap-3">
                          <br></br>
                          <h2> {selectAticle.label}</h2>
                        </div>
                      </div>
                      <div
                        className="mt-4 text-muted"
                        style={{ textAlign: "justify" }}
                      >
                        <p>{selectAticle.description}</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
              {!selectAticle.published && (
                <Form
                  encType="multipart/form-data"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                  }}
                >
                  <input
                    type="checkbox"
                    name="published"
                    className="form m-3"
                    style={{
                      fontWeight: "30px",
                      width: "15px",
                      height: "15px",
                    }}
                    value={validation.values.published}
                    onChange={validation.handleChange}
                  />
                  <b> J'ai vérifié cette innovation et je la valide.</b>
                  <div className="text-end mb-3">
                    <Link to="/innovations" className="btn btn-primary">
                  {props.t("Retour")}
                </Link>
                    <button type="submit" className="btn btn-warning mx-3">
                      {props.t("Valider l'innovation")}
                    </button>
                  </div>
                </Form>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

InnovationsDetail.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(InnovationsDetail));
